import React, { useEffect, useState } from "react";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DriverNotificationActions from "../../../store/actions/DriverNotification";
import Button from "sushiweb/Button";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import CampaignList from "../../../components/DriverNotification/CampaignList";
import Permission from "../../../components/Common/Permission";
import FilterButton from "../../../components/Common/FilterButton";
import ListPagination from "../../../components/Common/ListPagination";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import { BottomSectionModal } from "../../../constants/assets/containers";
export function ScheduledNotifications(props) {
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION];

  const {
    getScheduledNotificationsList,
    scheduledNotificationsList,
    setActiveCampaign,
    nextPage,
    prevPage,
    activeFilters,
    currentLastEvaluatedKey,
    lastEvaluatedKeyList,
    updateEvaluationKeyList,
    clearEvaluatedKeyList,
    editCampaign
  } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState(false);
  const [formError, setFormError] = useState("");
  const filterOptions = [
    { label: "Campaign ID", value: "id" },
  ];

  const [filterInputState, setFilterInputState] = useState({
    type: "",
    campaign_name: "",
    campaign_id: "",
  });

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      if (lastEvaluatedKeyList.length > 1){
        if (lastEvaluatedKeyList.length > 2) {
          pageRequest["last_evaluated_key"] = lastEvaluatedKeyList[lastEvaluatedKeyList.length - 3];
        }
        updateEvaluationKeyList();
      }
      setCurrentPage(currentPage - 1);
      getScheduledNotificationsList(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
        last_evaluated_key : currentLastEvaluatedKey
      };
      setCurrentPage(currentPage + 1);
      getScheduledNotificationsList(activeFilters, pageRequest);
    }
  };

  const handleViewDetails = (campaign_id) => {
    props.resetState("activeCampaign");
    history.push(`/notification_campaigns/${encodeURIComponent(campaign_id)}`);
  };

  const handleDisable = (campaign_id) => {
    const userConfirmed = window.confirm("Are you sure you want to cancel this campaign?");
    let payload = {
        campaign_id: campaign_id,
        disable_campaign: true,
    }
    if (userConfirmed) {
      editCampaign(payload).then((res) => {
        if (res) {
          setTimeout(() => {
            history.push(`/notification_campaigns`);
            window.location.reload();
          }, 1000);
        }
      });
    } else if(!userConfirmed) {
      console.log("User chose not to cancel the campaign.");
    }
  };

  const handleFilterModalClose = () => {
    setModalState(false);
    setFormError("");
  };

  const handleClearFilters = () => {
    clearEvaluatedKeyList()
    getScheduledNotificationsList().then((res) => {
      handleFilterModalClose();
    });
  };

  const handleFiltersApply = (e) => {
    let filters = {};
    if (filterInputState.type == "") {
      setFormError("Please select filter type");
      return;
    }
    if (filterInputState.type == "name") {
      if (filterInputState.campaign_name == "") {
        setFormError("Please select campaign name");
        return;
      }
      filters["campaign_name"] = filterInputState.campaign_name;
    }
    if (filterInputState.type == "id") {
      if (filterInputState.campaign_id == "") {
        setFormError("Please select campaign ID");
        return;
      }
      filters["campaign_id"] = filterInputState.campaign_id;
    }
    getScheduledNotificationsList(filters).then((res) => {
      handleFilterModalClose();
    });
  };

  const handleFilterChange = (key, val) => {
    setFilterInputState((prevState) => {
      return { ...prevState, [key]: val };
    });
  };

  const getInputLabel = (val, options, fromKey, toKey) => {
    const activeElement = options.find((item) => item[fromKey] === val);
    return activeElement ? activeElement[toKey] : val;
  };

  const getModal = () => {
    switch (modalState) {
      case "Filter":
        return (
          <NoFooterModal
            header={true}
            heading="Filter Campaign"
            handleClose={handleFilterModalClose}
            id="DriverCampaignFilterModal"
            modalButtons={
              <BottomSectionModal className="flex items-center justify-between">
                <Button
                  data-testid="filterClearBtn"
                  onClick={handleClearFilters}
                  className="sushi-btn"
                >
                  Clear
                </Button>
                <Button
                  data-testid="filterSubmitButton"
                  className="sushi-btn"
                  onClick={handleFiltersApply}
                >
                  Apply
                </Button>
              </BottomSectionModal>
            }
          >
            <PaginatedReactDropdown
              options={filterOptions}
              labelKey="label"
              valueKey="value"
              data-testid="filterType"
              value={getInputLabel(
                filterInputState.type,
                filterOptions,
                "value",
                "label"
              )}
              handleChange={handleFilterChange}
              keyToChange="type"
              placeholder="Filter by"
              labelWidth="10%"
              id="filterType"
            />
            {filterInputState.type != "" ? (
              <Input
                value={
                  filterInputState.type == "name"
                    ? filterInputState.campaign_name
                    : filterInputState.campaign_id
                }
                data-testid="filterBy"
                onChange={(e) =>
                  handleFilterChange(
                    `${
                      filterInputState.type == "name"
                        ? "campaign_name"
                        : "campaign_id"
                    }`,
                    e
                  )
                }
                id="sushi-input"
                label={`${
                  filterInputState.type == "name"
                    ? "Campaign Name"
                    : "Campaign ID"
                }`}
              />
            ) : (
              ""
            )}
            {formError.length > 0 ? (
              <div className={"error-state"}>{"*" + formError}</div>
            ) : (
              ""
            )}
          </NoFooterModal>
        );
    }
  };
  const handleCreateCampaignClick = () => {
    props.resetState("createCampaign");
    history.push(`/notification_campaign/create_campaign`);
  };

  useEffect(() => {
    scheduledNotificationsList.length == 0 && getScheduledNotificationsList();
    setActiveCampaign({});
  }, []);

  useEffect(() => {
    if (activeFilters && modalState === "Filter") {
      let values = { ...filterInputState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      if (values["campaign_id"] != "") {
        values["type"] = "id";
      }
      if (values["campaign_name"] != "") {
        values["type"] = "name";
      }
      setFilterInputState(values);
    }
  }, [scheduledNotificationsList, activeFilters]);

  return (
    <div className="container">
      <FlexContainer align="flex-start">
        <Heading>&emsp;Scheduled Notification Campaigns</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.CAMPAIGN_VIEW]}>
            <FilterButton
              activeFilters={activeFilters}
              handleClick={() => setModalState("Filter")}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CAMPAIGN_CREATE]}>
            <Button
              onClick={() => handleCreateCampaignClick()}
              className="sushi-btn ml-12"
              data-testid="CitiesAddBtn"
            >
              Create campaign
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.CAMPAIGN_VIEW]}>
        <CampaignList
          handleViewDetails={handleViewDetails}
          campaignList={scheduledNotificationsList}
          handleDisable={handleDisable}
        />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
          lastEvaluatedKeysList={lastEvaluatedKeyList}
          currentPageLastEvaluatedKey={currentLastEvaluatedKey}
        />
      </Permission>
      {modalState && getModal()}
    </div>
  );
}

function mapStateToProps(state) {
  const { DriverNotification } = state;
  return {
    scheduledNotificationsList: DriverNotification.scheduledNotificationsList,
    nextPage: DriverNotification.nextPage,
    prevPage: DriverNotification.prevPage,
    activeFilters: DriverNotification.activeFilters,
    currentLastEvaluatedKey: DriverNotification.currentLastEvaluatedKey,
    lastEvaluatedKeyList: DriverNotification.lastEvaluatedKeyList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getScheduledNotificationsList: bindActionCreators(
      DriverNotificationActions.getScheduledNotificationsList,
      dispatch
    ),
    setActiveCampaign: bindActionCreators(
      DriverNotificationActions.setActiveCampaign,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverNotificationActions.resetState,
      dispatch
    ),
    updateEvaluationKeyList: bindActionCreators(
      DriverNotificationActions.updateEvaluationKeyList,
      dispatch
    ),
    clearEvaluatedKeyList: bindActionCreators(
      DriverNotificationActions.clearEvaluatedKeyList,
      dispatch
    ),
    editCampaign: bindActionCreators(
        DriverNotificationActions.editCampaign,
        dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledNotifications);
